const BASE = process.env.REACT_APP_BACKEND_URL;

// Order photos are served from OUR origin (backend proxies Drive) so the
// China factory — which cannot reach Google — still sees every picture.
export const photoUrl = (orderId, fileId, size = "thumb") =>
  `${BASE}/api/orders/${orderId}/photo/${fileId}?size=${size}`;

// Old-worksheet rows: photos come from the "Caliper Gallery" folder matched by PO number.
export const archivePhotoUrl = (rowId, fileId, size = "thumb") =>
  `${BASE}/api/report/archive-photo/${rowId}/${fileId}?size=${size}`;

export const isImageFile = (f) => (f?.mimeType || "").startsWith("image/");

// Factory staff have no Google access — hide every "Open in Drive" link for them.
export const canOpenDrive = (user) => !/^factory_/.test(user?.role || "");
